import { useStyles } from "./style";

export default function UnAuthenticatedError() {
  const styles = useStyles();
  return <div className={styles.loginerror}>Sign-In by click the sigin button in the menu present in alphascript.</div>;
}
